import styled from 'styled-components';

const VisuallyHiddenText = styled.span`
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
`;

export default VisuallyHiddenText;
